import { useGetUserProfile } from 'hooks/queries/use-get-user-profile.hook';

const HOME_LOCATION_TYPE = 'home';

export const usePersonalInformation = () => {
  const { data, isLoading, error } = useGetUserProfile();

  const firstName = data?.userProfile?.firstName || '';
  const lastName = data?.userProfile?.lastName || '';

  const preferredFirstName = data?.userProfile?.preferredFirstName;

  // If preferredFirstName is not set, we use the firstName and lastName which is different from the dropdown requirement
  const displayName = preferredFirstName
    ? `${preferredFirstName}`
    : `${firstName} ${lastName}`;

  // Get home address from locations
  const homeLocation = data?.userProfile?.locations?.find(
    (location: { type: string | undefined }) =>
      location.type === HOME_LOCATION_TYPE,
  );

  const phoneNumber = data?.phoneNumber ?? '';

  return {
    data: {
      ...data,
      userProfile: {
        ...data?.userProfile,
        firstName,
        lastName,
        displayName,
        preferredFirstName,
        homeLocation,
        phoneNumber,
      },
    },
    isLoading,
    error,
  };
};
